import Vue from "vue";
import VueSnackbar from "vue-snack";

const vm = new Vue({
  methods: {
    success(text) {
      this.$snack.success({
        text,
        button: "X",
      });
    },
    error(text) {
      this.$snack.error({
        text,
        button: "X",
      });
    },
    warning(text) {
      this.$snack.warning({
        text,
        button: "X",
      });
    },
  },
});

const snackConfig = {
  position: "top-left",
  time: 3000,
  methods: [
    { name: "success", color: "#28a745" },
    { name: "error", color: "#dc3545" },
    { name: "warning", color: "#ffc107" },
  ],
};

vm.$set(VueSnackbar, snackConfig);
const $snack = vm;

export { snackConfig, $snack };
